import React from 'react'
import irelandApi from '../irelandApi'
import {actions} from 'react-redux-form'
import store, {history} from '../store'
import setAuthorizationToken, {clear} from '../utils/tokenUtils'
import {toast} from "react-toastify";
import ToastMessage from "../components/common/toast-message";

export const welcomeAction = (payload, dispatch) => {
  dispatch({type: 'PATCH_WELCOME_PENDING'});
  return irelandApi.patch('/api/admin/users/invitation', {user: payload})
    .then((response) => {
      const token = response.headers.authorization.split(' ')[1];
      clear();
      setAuthorizationToken(token);
      toast.success(<ToastMessage iconStyle="success" message="Your data has been successfully saved."/>);
      dispatch({type: 'PATCH_WELCOME_FULFILLED', payload: response.data});
      window.location.href = '/admin/my-profile';
    })
    .catch((error) => {
      dispatch({type: 'PATCH_WELCOME_REJECTED', payload: error.response.data.errors});
      if (typeof error.response.data.errors == 'string') {
        toast.error(<ToastMessage iconStyle="error" message={error.response.data.errors}/>);
      }

      return Promise.reject(error.response.data.errors);
    })
};



// WEBPACK FOOTER //
// ./src/actions/welcome.js